/* eslint-disable class-methods-use-this */

/**
 * All Stores should extend this class but this class should never be
 * instantiated directly.
 */
class BaseStore {
  constructor(name, version) {
    this.debug = false;
    this.name = name;
    this.version = version;
  }

  setDebug(onOrOff) {
    this.debug = Boolean(onOrOff);
  }

  debugMsg(...args) {
    if (this.debug || window.showAtsDebugMessage === true) {
      // eslint-disable-next-line no-console
      console.log(`[${this.name}]`, ...args);
    }
  }

  set(key, data, expiresAt) {
    console.warn('`set` not implemented.', key, data, expiresAt);
  }

  update(key, data, expiresAt) {
    console.warn('`update` not implemented.', key, data, expiresAt);
  }

  get(key) {
    return new Promise(() => {
      console.warn('`get` not implemented.', key);
    });
  }

  async upsert(key, data, expiresAt) {
    console.warn('`upsert` not implemented.', key, data, expiresAt);
  }

  delete(key) {
    return new Promise(() => {
      console.warn('`delete` not implemented.', key);
    });
  }

  deleteStartsWith(substring) {
    return new Promise(() => {
      console.warn('`delete` not implemented.', substring);
    });
  }

  // Delete all entries with the prefix
  clear() {
    console.warn('`clear` not implemented.');
  }
}

export default BaseStore;
